export default __webpack_public_path__ + "static/media/2_icon1A.ddf265cb.png";